module.exports = __webpack_public_path__ + "img/NightCastleStableShot.a22e931f.webp";